import { INITIALIZE_APP } from './types';

export const initApp = () => {
  return {
    type: INITIALIZE_APP,
  };
};
